/**
 * Stock Transfer Model - Processes API responses for stock transfer data
 */

/**
 * Process stock transfer list response data
 * @param {Object} response - API response from stock transfer list endpoint
 * @returns {Object} Formatted stock transfer list data
 */
export const stockTransferListGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        return {
            success: true,
            total: response.data.total || response.data.data.length,
            data: response.data.data
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch stock transfer list',
        data: []
    };
};

/**
 * Process stock transfer creation response
 * @param {Object} response - API response from stock transfer create endpoint
 * @returns {Object} Formatted creation response
 */
export const stockTransferCreatePost = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Stock transfer created successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to create stock transfer',
        data: null
    };
};

/**
 * Process single stock transfer details response
 * @param {Object} response - API response from stock transfer details endpoint
 * @returns {Object} Formatted stock transfer details
 */
export const stockTransferDetailsGet = (response) => {
    // Based on Postman collection response format
    if (response && response.data && response.data.success === true) {
        const item = response.data.data || {};
        return {
            success: true,
            data: item
        };
    }
    return {
        success: false,
        message: response?.data?.message || 'Failed to fetch stock transfer details',
        data: {}
    };
};

/**
 * Process stock transfer update response
 * @param {Object} response - API response from stock transfer update endpoint
 * @returns {Object} Formatted update response
 */
export const stockTransferUpdatePut = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Stock transfer updated successfully',
            data: response.data.data || null
        };
    }
    return {
        success: false,
        message: 'Failed to update stock transfer',
        data: null
    };
};

/**
 * Process stock transfer delete response
 * @param {Object} response - API response from stock transfer delete endpoint
 * @returns {Object} Formatted delete response
 */
export const stockTransferDeleteDel = (response) => {
    // Based on Postman collection response format
    if (response && response.data) {
        return {
            success: response.data.success === true,
            message: response.data.message || 'Stock transfer deleted successfully'
        };
    }
    return {
        success: false,
        message: 'Failed to delete stock transfer'
    };
};